import styled from 'styled-components'

export const MainContentWithInset = styled.div`
  margin: 0;
`
